// 🔑 **TODO.md F-06 / F-170. A page `<template>`'s content moved into `#mainModal`, in one place.**
//
// Two features reached this shape independently — `F-170`'s own-booking confirmation and `F-06`'s help
// button — and `shared/_page_title` already described them as one pattern while they were two copies
// (`/simplify`, 2026-10-28).
//
// 📌 A `<template>` rather than a fetch: the content is known at render time, so a round trip would buy
// nothing and could fail. The markup is built by ERB, not assembled here.
//
// ⚠️ **Takes the ELEMENT, never an id**, and that is the whole reason this is shared rather than copied.
// `src/helpModal.js` deliberately finds its template relative to the clicked button, because with the
// offcanvas open over an index page there are TWO in the document and `getElementById` returns the first
// — so the tab's help would show the index's text. A helper that looked the element up itself would put
// that trap back for the next caller.
export default (template) => {
  if (!template) { return false }

  $('#mainModal').html(template.innerHTML)
  return true
}
